import { axios } from '~/plugins/axios'

export default class Tutorial {
  static finish(tutorial){
    axios.put('tutorial/' + tutorial + '/finish', null, {
      showLoading: false
    })
  }
}
